import { Box, Typography, Stack } from "@mui/material";
import React, { useState, useRef } from "react";
import UserMaintenanceComponent from "./userMaintenance";
import {
  getUserMaintanenceData,
  uploadUserRoles,
} from "../../Redux/UserMaintanence";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import AddUser from "./AddUser";
import Alert from "@mui/material/Alert";
import "./UserMaintenance.css";

function UserMaintaneneceContent() {
  const dispatch = useDispatch();
  const [openEdit, setOpenEdit] = React.useState(false);
  const initData = useSelector((state) => state.userRoles.UserMaintanenceData);
  const [isAlertSec, setisAlertSec] = React.useState(false);

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    "&:hover": {
      backgroundColor: "#7500C0",
      color: "#fff",
    },
  }));
  useEffect(() => {
    dispatch(getUserMaintanenceData());
  }, []);
  const handleOpenAdd = () => {
    setOpenEdit(true);
  };
  const [file, setFile] = useState("");
  const ref = useRef();
  const saveFile = (e) => {
    setFile(e.target.files[0]);
  };
  const uploadFile = () => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadUserRoles(formData));
  };

  return (
    <Box>
      <div className="maintainPlusAdd" style={{ position: "relative" }}>
        <Box
          sx={{
            width: "95%",
            display: "flex",
            justifyContent: "end",
            position: "absolute",
          }}
        >
          <AddUser
          openEdit={openEdit}
          setOpenEdit={setOpenEdit}
          initData={initData}
        />
        </Box>
        <Box sx={{ width: "100%" }}>
          <UserMaintenanceComponent
            isAlertSec={isAlertSec}
            setisAlertSec={setisAlertSec}
            initData={initData}
          />
        </Box>

      </div>
    </Box>
  )
}

export default UserMaintaneneceContent;
